
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RackPositionModel } from '.';

export class RackPositionResponseModel extends GlobalResponseObject {
    data?: RackPositionModel[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /RackPositionModel
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RackPositionModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 